import React, { useEffect } from "react";
import { useVeltClient } from "../context";
export function useLiveSelectionUtils() {
    var _a = React.useState(), selectionElement = _a[0], setSelectionElement = _a[1];
    var client = useVeltClient().client;
    React.useEffect(function () {
        if (!client || selectionElement)
            return;
        var loadedSelectionElement = client.getSelectionElement();
        setSelectionElement(loadedSelectionElement);
    }, [client, setSelectionElement, selectionElement]);
    return selectionElement;
}
export function useLiveSelectionDataHandler() {
    var selectionElement = useLiveSelectionUtils();
    var _a = React.useState(null), data = _a[0], setData = _a[1];
    useEffect(function () {
        if (!(selectionElement === null || selectionElement === void 0 ? void 0 : selectionElement.getLiveSelectionData))
            return;
        var subscription = selectionElement.getLiveSelectionData().subscribe(function (res) {
            setData(res);
        });
        return function () {
            subscription.unsubscribe();
        };
    }, [selectionElement === null || selectionElement === void 0 ? void 0 : selectionElement.getLiveSelectionData]);
    return data;
}
